import React, { useState } from 'react';
import styled from 'styled-components';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface Props {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const Wrapper = styled.div`
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  margin-bottom: 16px;
  background: white;
  overflow: hidden;
`;

const Header = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: var(--background-secondary, #f7f8fa);
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  direction: rtl;
  text-align: right;
  transition: background-color 0.15s ease;

  &:hover {
    background: var(--hover-background, #eef0f3);
  }
`;

const Body = styled.div<{ $open: boolean }>`
  max-height: ${p => (p.$open ? '4000px' : '0')};
  overflow: ${p => (p.$open ? 'visible' : 'hidden')};
  transition: max-height 0.3s ease;
`;

const Inner = styled.div`
  padding: 16px;
`;

/**
 * חלק אקורדיון בסיסי לעטיפת קבוצות שדות. ברירת מחדל — מקופל.
 */
const CollapsibleSection: React.FC<Props> = ({ title, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Wrapper>
      <Header type="button" onClick={() => setOpen(o => !o)}>
        <span>{title}</span>
        {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </Header>
      <Body $open={open}>
        <Inner>{children}</Inner>
      </Body>
    </Wrapper>
  );
};

export default CollapsibleSection;
